import {isWorkspaceOwner} from "../../../system/workspace-permissions";

function identityCandidates(value) {
    if (value === null || value === undefined || value === "") return [];
    if (typeof value !== "object") return [String(value)];
    return [value.documentId, value.id]
        .filter((item) => item !== null && item !== undefined && item !== "")
        .map(String);
}

function sameIdentity(left, right) {
    const rightIdentities = new Set(identityCandidates(right));
    return identityCandidates(left).some((identity) => rightIdentities.has(identity));
}

export function isActiveStrategyMapEntity(entity, workspace) {
    return Boolean(entity)
        && entity.archivedAt == null
        && sameIdentity(entity.workspace, workspace);
}

export function filterStrategyMapEntities(entities, workspace) {
    return (Array.isArray(entities) ? entities : [])
        .filter((entity) => isActiveStrategyMapEntity(entity, workspace));
}

export function canEnterStrategyMapEntity(entity, workspaceMembership) {
    if (!entity || !workspaceMembership) return false;
    if (isWorkspaceOwner(workspaceMembership)) return true;

    const directMembers = Array.isArray(entity.members) ? entity.members : [];
    const teamMembers = Array.isArray(entity.team?.members) ? entity.team.members : [];

    return directMembers.some((membership) => sameIdentity(membership, workspaceMembership))
        || sameIdentity(entity.owner, workspaceMembership)
        || teamMembers.some((membership) => sameIdentity(membership, workspaceMembership))
        || sameIdentity(entity.team?.owner, workspaceMembership);
}
